<p-icon class="busy-icon" name="loader" size="sm"></p-icon>
<span><ng-content></ng-content></span>
